import React, { useState } from "react";
import MainCalculatorsList from "./CountriesMainCalculatorsList/SyriaMainCalculator";
import RelatedLinks from "../RelatedLinks";
import { SecondAds, FirstAds, MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "حاسبة فاتورة المياه في سوريا - احسب تكلفة استهلاكك الشهري";
const DESCRIPTION =
  "احسب قيمة فاتورة المياه بدقة باستخدام التعريفة الرسمية الجديدة. أدخل استهلاكك واحصل على حساب تفصيلي فوري للشرائح - أداة مجانية سهلة الاستخدام";
const KEYWORDS = "حاسبة فاتورة المياه, حساب استهلاك المياه سوريا, تعريفة المياه الجديدة, أسعار المياه, متر مكعب";
const OG_URL =
  "https://do-calculate.com/calculator/ar/countries/SY/calculators-list/water-calculator/";
// بيانات استهلاك المياه التقريبي
const WATER_USAGE_DATA = {
  daily: [
    { name: "الاستحمام (10 دقائق)", usage: 0.08, emoji: "🚿" },
    { name: "غسل الأسنان (مرتين يومياً)", usage: 0.006, emoji: "🪥" },
    { name: "استخدام المرحاض (6 مرات)", usage: 0.054, emoji: "🚽" },
    { name: "غسل الوجه واليدين", usage: 0.015, emoji: "🧼" },
  ],
  kitchen: [
    { name: "غسل الصحون يدوياً", usage: 0.04, emoji: "🍽️" },
    { name: "استخدام غسالة الصحون", usage: 0.015, emoji: "🔲" },
    { name: "الطبخ وتحضير الطعام", usage: 0.02, emoji: "👨‍🍳" },
    { name: "شرب الماء والطعام", usage: 0.01, emoji: "🥤" },
  ],
  laundry: [
    { name: "غسالة أوتوماتيك (دورة واحدة)", usage: 0.08, emoji: "👕" },
    { name: "غسيل يدوي", usage: 0.04, emoji: "🧺" },
  ],
  cleaning: [
    { name: "تنظيف الأرضيات", usage: 0.03, emoji: "🧹" },
    { name: "غسيل السيارة", usage: 0.15, emoji: "🚗" },
    { name: "سقي النباتات والحديقة", usage: 0.05, emoji: "🌱" },
  ]
};
function WaterCalculator() {
  const [consumption, setConsumption] = useState("");
  const [usageType, setUsageType] = useState("residential");
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const [dailyUsage, setDailyUsage] = useState({});
  // التاريخ الحالي
  const today = new Date().toLocaleDateString('ar-SY', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
  const calculateBill = () => {
    try {
      setError("");
      const cubicMeters = parseFloat(consumption);
      if (isNaN(cubicMeters) || cubicMeters <= 0) {
        setError("يرجى إدخال قيمة استهلاك صالحة");
        return;
      }
      let totalCost = 0;
      let tiers = [];
      if (usageType === "residential") {
        // الشرائح السكنية (الأسعار بالعملة القديمة)
        const residentialTiers = [
          { from: 1, to: 5, price: 0, priceOld: 0, label: "1-5 متر مكعب" },
          { from: 6, to: 15, price: 0.07, priceOld: 7, label: "6-15 متر مكعب" },
          { from: 16, to: 25, price: 0.15, priceOld: 15, label: "16-25 متر مكعب" },
          { from: 26, to: 35, price: 0.22, priceOld: 22, label: "26-35 متر مكعب" },
          { from: 36, to: Infinity, price: 1.50, priceOld: 150, label: "36+ متر مكعب" }
        ];
        let remaining = cubicMeters;
        residentialTiers.forEach(tier => {
          if (remaining > 0) {
            const tierStart = tier.from;
            const tierEnd = tier.to === Infinity ? Infinity : tier.to;
            const tierSize = tierEnd === Infinity ? Infinity : tierEnd - tierStart + 1;
            let consumed = 0;
            if (remaining >= tierSize) {
              consumed = tierSize;
              remaining -= tierSize;
            } else {
              consumed = remaining;
              remaining = 0;
            }
            const cost = consumed * tier.price;
            const costOld = consumed * tier.priceOld;
            if (consumed > 0) {
              tiers.push({
                label: tier.label,
                consumed: consumed,
                price: tier.price,
                priceOld: tier.priceOld,
                cost: cost,
                costOld: costOld
              });
              totalCost += cost;
            }
          }
        });
      } else {
        // الشرائح الصناعية/التجارية (الأسعار بالعملة القديمة)
        const industrialTiers = [
          { from: 1, to: 10, price: 10, priceOld: 1000, label: "1-10 متر مكعب" },
          { from: 11, to: 60, price: 15, priceOld: 1500, label: "11-60 متر مكعب" },
          { from: 61, to: Infinity, price: 20, priceOld: 2000, label: "61+ متر مكعب" }
        ];
        let remaining = cubicMeters;
        industrialTiers.forEach(tier => {
          if (remaining > 0) {
            const tierStart = tier.from;
            const tierEnd = tier.to === Infinity ? Infinity : tier.to;
            const tierSize = tierEnd === Infinity ? Infinity : tierEnd - tierStart + 1;
            let consumed = 0;
            if (remaining >= tierSize) {
              consumed = tierSize;
              remaining -= tierSize;
            } else {
              consumed = remaining;
              remaining = 0;
            }
            const cost = consumed * tier.price;
            const costOld = consumed * tier.priceOld;
            if (consumed > 0) {
              tiers.push({
                label: tier.label,
                consumed: consumed,
                price: tier.price,
                priceOld: tier.priceOld,
                cost: cost,
                costOld: costOld
              });
              totalCost += cost;
            }
          }
        });
      }
      setResult({
        totalCost,
        totalCostOld: totalCost * 100,
        totalCubicMeters: cubicMeters,
        tiers
      });
    } catch (error) {
      setError("حدث خطأ في الحساب");
    }
  };
  const updateDailyUsage = (category, name, times) => {
    const id = `${category}-${name}`;
    const updatedUsage = {
      ...dailyUsage,
      [id]: parseFloat(times) || 0
    };
    setDailyUsage(updatedUsage);
    let total = 0;
    Object.entries(WATER_USAGE_DATA).forEach(([cat, items]) => {
      items.forEach(item => {
        const itemId = `${cat}-${item.name}`;
        const timesUsed = updatedUsage[itemId] || 0;
        if (timesUsed > 0) {
          const monthly = item.usage * timesUsed * 30;
          total += monthly;
        }
      });
    });
    if (total > 0) {
      setConsumption(total.toFixed(1));
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div className="bg-success text-white text-center" style={{ height: '40px', }}>
            <h1 style={{ fontSize: "17px", margin: 0 }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div className="p-3">
                <p>
                  هل تريد معرفة القيمة المتوقعة لفاتورتك الشهرية للمياه؟ أداتنا توفر لك حساباً
                  دقيقاً لتكلفة استهلاك المياه وفق التعريفة الرسمية المعتمدة. ببساطة،
                  أدخل استهلاكك الشهري بالمتر المكعب واحصل فوراً على التفاصيل الكاملة
                  للفاتورة مع توزيع التكلفة على الشرائح المختلفة.
                </p>
                <p>
                  تعتمد الحاسبة على نظام التسعير الرسمي المعتمد من الجهات المختصة في سوريا،
                  والذي يقسم الاستهلاك المنزلي إلى خمس شرائح بأسعار متدرجة. الاستهلاك المنخفض
                  يحظى بأسعار مخفضة لتشجيع الترشيد، بينما الاستهلاك المرتفع يخضع لتعريفة أعلى.
                </p>
                <p>
                  معرفة تفاصيل فاتورتك تساعدك على التخطيط المالي الأفضل وفهم كيفية توزيع
                  التكاليف. كما يمكنك استخدام قسم حساب الاستهلاك اليومي أدناه لمعرفة مقدار
                  المياه التي تستهلكها في أنشطتك اليومية، مما يساعدك على اتخاذ قرارات ذكية
                  لتوفير المياه والمال.
                </p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="bg-success text-white text-center">
                  <h2 style={{ fontSize: "16px", margin: 0 }}>{TITLE}</h2>
                </div>
                <div className="bg-warning text-black text-center p-2">
                  <u><b>ملاحظة هامة</b>:</u>{" "}
                  <b>
                    تاريخ آخر تحديث: <time dateTime={new Date().toISOString().split('T')[0]}>{today}</time>
                  </b>
                </div>
                <div className="p-3">
                  <div className="form-group mb-3">
                    <label><strong>نوع الاشتراك:</strong></label>
                    <select
                      className="form-control"
                      value={usageType}
                      onChange={(e) => setUsageType(e.target.value)}
                    >
                      <option value="residential">🏠 سكني (منزلي)</option>
                      <option value="industrial">🏭 صناعي / تجاري</option>
                    </select>
                  </div>
                  <div className="form-group mb-3">
                    <label htmlFor="consumption"><strong>الاستهلاك الشهري (متر مكعب):</strong></label>
                    <input
                      id="consumption"
                      type="number"
                      value={consumption}
                      onChange={(e) => setConsumption(e.target.value)}
                      className="form-control mb-2"
                      placeholder="مثال: 25"
                    />
                  </div>
                  {usageType === "residential" && (
                    <div className="alert alert-info">
                      <strong>📊 نظام الشرائح السكنية:</strong>
                      <ul style={{ marginBottom: 0, marginTop: "10px", paddingRight: "20px" }}>
                        <li>الشريحة الأولى (1-5 م³): <strong>مجاناً</strong></li>
                        <li>الشريحة الثانية (6-15 م³): <strong>7 ل.س/م³</strong> <small className="text-muted">(0.07 ل.س العملة الجديدة)</small></li>
                        <li>الشريحة الثالثة (16-25 م³): <strong>15 ل.س/م³</strong> <small className="text-muted">(0.15 ل.س العملة الجديدة)</small></li>
                        <li>الشريحة الرابعة (26-35 م³): <strong>22 ل.س/م³</strong> <small className="text-muted">(0.22 ل.س العملة الجديدة)</small></li>
                        <li>الشريحة الخامسة (+36 م³): <strong>150 ل.س/م³</strong> <small className="text-muted">(1.50 ل.س العملة الجديدة)</small></li>
                      </ul>
                    </div>
                  )}
                  {usageType === "industrial" && (
                    <div className="alert alert-info">
                      <strong>📊 نظام الشرائح الصناعية/التجارية:</strong>
                      <ul style={{ marginBottom: 0, marginTop: "10px", paddingRight: "20px" }}>
                        <li>الشريحة الأولى (1-10 م³): <strong>1,000 ل.س/م³</strong> <small className="text-muted">(10 ل.س العملة الجديدة)</small></li>
                        <li>الشريحة الثانية (11-60 م³): <strong>1,500 ل.س/م³</strong> <small className="text-muted">(15 ل.س العملة الجديدة)</small></li>
                        <li>الشريحة الثالثة (+61 م³): <strong>2,000 ل.س/م³</strong> <small className="text-muted">(20 ل.س العملة الجديدة)</small></li>
                      </ul>
                    </div>
                  )}
                  <br />
                  <button
                    className="text-white"
                    style={{ fontSize: "20px", marginLeft: "10px", padding: "10px 30px", border: "none", borderRadius: "5px", backgroundColor: "#0d5e3a" }}
                    onClick={calculateBill}
                  >
                    احسب                  </button>
                </div>
                { error !== "" ? (
                  <p className="p-3 mb-2 bg-warning text-white">خطأ: {error}</p>
                ) : (
                  result !== null && (
                    <div className="bg-success text-white text-center">
                      <h3 style={{ fontSize: "16px", marginBottom: "15px" }}>نتيجة الحساب</h3>
                      <div style={{ fontSize: "14px", marginBottom: "15px" }}>
                        {result.tiers.map((tier, index) => (
                          <div key={index} style={{ marginBottom: "10px", paddingBottom: "10px", borderBottom: index < result.tiers.length - 1 ? "1px solid rgba(255,255,255,0.3)" : "none" }}>
                            <strong>{tier.label}</strong>
                            <br />
                            {tier.consumed.toFixed(2)} × {tier.priceOld.toLocaleString()} ل.س = {tier.costOld.toLocaleString()} ل.س
                          </div>
                        ))}
                      </div>
                      <div style={{ borderTop: "2px solid white", paddingTop: "15px" }}>
                        <p style={{ fontSize: "18px", marginBottom: "5px" }}>
                          <strong>💰 التكلفة الإجمالية</strong>
                        </p>
                        <p style={{ fontSize: "16px", marginBottom: "5px" }}>
                          🇸🇾 <strong>{result.totalCost.toFixed(2)} ل.س</strong> (الليرة السورية الجديدة)
                        </p>
                        <p style={{ fontSize: "14px", opacity: 0.9 }}>
                          🇸🇾 {result.totalCostOld.toLocaleString()} ل.س (العملة القديمة)
                        </p>
                      </div>
                    </div>
                  )
                )}
              </div>
              <div className="col-sm-12 col-md-5">
                {/* جدول الأسعار الرسمية */}
                <div className="calculatorStyle">
                  <div className="bg-success text-white text-center">
                    <h3 style={{ fontSize: "16px", margin: 0 }}>📋 جدول الأسعار الرسمية</h3>
                  </div>
                  <div className="p-3">
                    <div className="mb-3">
                      <strong>🏠 الاستخدام المنزلي</strong>
                      <table className="table table-sm mt-2" style={{ tableLayout: "fixed" }}>
                        <tbody>
                          <tr>
                            <td style={{ width: "50%" }}>1-5 م³</td>
                            <td style={{ width: "50%" }}>
                              <strong>مجاناً</strong>
                            </td>
                          </tr>
                          <tr>
                            <td>6-15 م³</td>
                            <td>
                              <strong>7 ل.س</strong>
                              <br />
                              <small className="text-muted">(0.07 ل.س الجديدة)</small>
                            </td>
                          </tr>
                          <tr>
                            <td>16-25 م³</td>
                            <td>
                              <strong>15 ل.س</strong>
                              <br />
                              <small className="text-muted">(0.15 ل.س الجديدة)</small>
                            </td>
                          </tr>
                          <tr>
                            <td>26-35 م³</td>
                            <td>
                              <strong>22 ل.س</strong>
                              <br />
                              <small className="text-muted">(0.22 ل.س الجديدة)</small>
                            </td>
                          </tr>
                          <tr>
                            <td>+36 م³</td>
                            <td>
                              <strong>150 ل.س</strong>
                              <br />
                              <small className="text-muted">(1.50 ل.س الجديدة)</small>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div>
                      <strong>🏭 الاستخدام الصناعي</strong>
                      <table className="table table-sm mt-2" style={{ tableLayout: "fixed" }}>
                        <tbody>
                          <tr>
                            <td style={{ width: "50%" }}>1-10 م³</td>
                            <td style={{ width: "50%" }}>
                              <strong>1,000 ل.س</strong>
                              <br />
                              <small className="text-muted">(10 ل.س الجديدة)</small>
                            </td>
                          </tr>
                          <tr>
                            <td>11-60 م³</td>
                            <td>
                              <strong>1,500 ل.س</strong>
                              <br />
                              <small className="text-muted">(15 ل.س الجديدة)</small>
                            </td>
                          </tr>
                          <tr>
                            <td>+61 م³</td>
                            <td>
                              <strong>2,000 ل.س</strong>
                              <br />
                              <small className="text-muted">(20 ل.س الجديدة)</small>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <br />
                {/* أمثلة سريعة */}
                <div className="calculatorStyle">
                  <div className="bg-success text-white text-center">
                    <h3 style={{ fontSize: "16px", margin: 0 }}>🧮 أمثلة سريعة (سكني)</h3>
                  </div>
                  <div className="p-3">
                    <div className="mb-2 p-2" style={{ border: "2px solid #0d5e3a", borderRadius: "5px" }}>
                      <strong>10 متر مكعب:</strong>
                      <br />
                      (5 × 0) + (5 × 7) = <strong>35 ل.س</strong>
                      <br />
                      <small className="text-muted">(0.35 ل.س العملة الجديدة)</small>
                    </div>
                    <div className="mb-2 p-2" style={{ border: "2px solid #0d5e3a", borderRadius: "5px" }}>
                      <strong>25 متر مكعب:</strong>
                      <br />
                      (5×0) + (10×7) + (10×15) = <strong>220 ل.س</strong>
                      <br />
                      <small className="text-muted">(2.20 ل.س العملة الجديدة)</small>
                    </div>
                    <div className="p-2" style={{ border: "2px solid #0d5e3a", borderRadius: "5px" }}>
                      <strong>40 متر مكعب:</strong>
                      <br />
                      (5×0) + (10×7) + (10×15) + (10×22) + (5×150) = <strong>1,660 ل.س</strong>
                      <br />
                      <small className="text-muted">(16.60 ل.س العملة الجديدة)</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr />
            {/* قسم حساب الاستهلاك اليومي */}
            <div className="row">
              <div className="col-sm-12 col-md-12 calculatorStyle">
                <div className="bg-success text-white text-center">
                  <h2 style={{ fontSize: "16px", margin: 0 }}>
                    💧 احسب استهلاكك من الأنشطة اليومية
                  </h2>
                </div>
                <div className="p-3">
                  <p>حدد عدد مرات استخدامك اليومي وسيتم حساب الاستهلاك الشهري تلقائياً</p>
                  {Object.entries(WATER_USAGE_DATA).map(([category, items]) => (
                    <div key={category} className="mb-4">
                      <h3 className="bg-success text-white text-center">
                        {category === 'daily' && '🚿 الاستخدام اليومي'}
                        {category === 'kitchen' && '🍳 المطبخ'}
                        {category === 'laundry' && '🧺 الغسيل'}
                        {category === 'cleaning' && '🧹 التنظيف'}
                      </h3>
                      <div className="row">
                        {items.map((item) => {
                          const id = `${category}-${item.name}`;
                          const times = dailyUsage[id] || 0;
                          const monthly = times > 0 ? item.usage * times * 30 : 0;
                          return (
                            <div className="col-sm-12 col-md-4 mb-3" key={id}>
                              <div style={{ minHeight: "160px", border: "2px solid #0d5e3a", borderRadius: "5px", overflow: "hidden" }}>
                                <div className="bg-success text-white text-center">
                                  <strong style={{ fontSize: "14px" }}>{item.emoji} {item.name}</strong>
                                </div>
                                <div className="p-3">
                                  <small className="text-muted d-block mb-2">
                                    الاستهلاك: {item.usage} م³/مرة
                                  </small>
                                  <div className="form-group mb-2">
                                    <label style={{ fontSize: "12px" }}>عدد المرات يومياً:</label>
                                    <input
                                      type="number"
                                      className="form-control form-control-sm"
                                      value={times || ''}
                                      onChange={(e) => updateDailyUsage(category, item.name, e.target.value)}
                                      placeholder="مثال: 2"
                                      min="0"
                                      step="1"
                                    />
                                  </div>
                                  {times > 0 && (
                                    <div className="d-block" style={{ color: "#0d5e3a" }}>
                                      <small>
                                        <strong>{monthly.toFixed(2)} م³/شهر</strong>
                                      </small>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <hr />
            {/* نصائح التوفير */}
            <div className="row">
              <div className="col-sm-12 col-md-12 calculatorStyle">
                <div className="bg-success text-white text-center">
                  <h2 style={{ fontSize: "16px", margin: 0 }}>نصائح لتوفير المياه</h2>
                </div>
                <div className="p-3">
                  <div className="row">
                    <div className="col-sm-12 col-md-6">
                      <div style={{ border: "2px solid #0d5e3a", borderRadius: "5px", overflow: "hidden" }}>
                        <div className="bg-success text-white text-center">
                          <strong style={{ fontSize: "14px" }}>أصلح التسريبات فوراً</strong>
                        </div>
                        <div className="p-3">
                          <p style={{ fontSize: "14px", marginBottom: 0 }}>
                            صنبور يقطر ببطء يهدر 20 لتراً يومياً (0.6 م³ شهرياً). فحص وإصلاح التسريبات يوفر
                            ما يصل إلى 10% من استهلاكك
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-6">
                      <div style={{ border: "2px solid #0d5e3a", borderRadius: "5px", overflow: "hidden" }}>
                        <div className="bg-success text-white text-center">
                          <strong style={{ fontSize: "14px" }}>استخدم رأس دش موفر</strong>
                        </div>
                        <div className="p-3">
                          <p style={{ fontSize: "14px", marginBottom: 0 }}>
                            رأس الدش الموفر يقلل التدفق من 15-20 لتر/دقيقة إلى 8-10 لتر/دقيقة، موفراً
                            40-50% من مياه الاستحمام (حوالي 2-3 م³ شهرياً)
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-6">
                      <div style={{ border: "2px solid #0d5e3a", borderRadius: "5px", overflow: "hidden" }}>
                        <div className="bg-success text-white text-center">
                          <strong style={{ fontSize: "14px" }}>اغلق الصنبور أثناء التنظيف</strong>
                        </div>
                        <div className="p-3">
                          <p style={{ fontSize: "14px", marginBottom: 0 }}>
                            إغلاق الصنبور أثناء تنظيف الأسنان أو الحلاقة يوفر 6-8 لترات في كل مرة،
                            أي حوالي 5-7 م³ شهرياً للعائلة
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-6">
                      <div style={{ border: "2px solid #0d5e3a", borderRadius: "5px", overflow: "hidden" }}>
                        <div className="bg-success text-white text-center">
                          <strong style={{ fontSize: "14px" }}>استخدم الغسالة عند الامتلاء</strong>
                        </div>
                        <div className="p-3">
                          <p style={{ fontSize: "14px", marginBottom: 0 }}>
                            تشغيل الغسالة عند الحمولة الكاملة فقط يوفر 40% من المياه والطاقة،
                            أي حوالي 3-4 م³ شهرياً
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-6">
                      <div style={{ border: "2px solid #0d5e3a", borderRadius: "5px", overflow: "hidden" }}>
                        <div className="bg-success text-white text-center">
                          <strong style={{ fontSize: "14px" }}>اجمع مياه الأمطار</strong>
                        </div>
                        <div className="p-3">
                          <p style={{ fontSize: "14px", marginBottom: 0 }}>
                            استخدم براميل لجمع مياه الأمطار لسقي النباتات والحديقة، موفراً
                            2-5 م³ شهرياً في موسم الأمطار
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-6">
                      <div style={{ border: "2px solid #0d5e3a", borderRadius: "5px", overflow: "hidden" }}>
                        <div className="bg-success text-white text-center">
                          <strong style={{ fontSize: "14px" }}>اغسل السيارة بالدلو</strong>
                        </div>
                        <div className="p-3">
                          <p style={{ fontSize: "14px", marginBottom: 0 }}>
                            غسل السيارة بالخرطوم يستهلك 150-200 لتر، بينما الدلو يستهلك 30-40 لتر فقط،
                            موفراً 80% من المياه
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-6">
                      <div style={{ border: "2px solid #0d5e3a", borderRadius: "5px", overflow: "hidden" }}>
                        <div className="bg-success text-white text-center">
                          <strong style={{ fontSize: "14px" }}>ركب موفرات المياه للصنابير</strong>
                        </div>
                        <div className="p-3">
                          <p style={{ fontSize: "14px", marginBottom: 0 }}>
                            موفرات الصنابير (Aerators) تقلل التدفق بنسبة 30-50% دون التأثير على
                            ضغط الماء، موفرة 3-5 م³ شهرياً
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-6">
                      <div style={{ border: "2px solid #0d5e3a", borderRadius: "5px", overflow: "hidden" }}>
                        <div className="bg-success text-white text-center">
                          <strong style={{ fontSize: "14px" }}>استخدم نظام الري بالتنقيط</strong>
                        </div>
                        <div className="p-3">
                          <p style={{ fontSize: "14px", marginBottom: 0 }}>
                            الري بالتنقيط يوصل الماء مباشرة للجذور، موفراً 50-70% من مياه الري
                            مقارنة بالرش العادي
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      {/* الأسئلة الشائعة */}
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">كيف يتم احتساب فاتورة المياه؟</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>نظام الشرائح للاستخدام المنزلي</h2>
                  </u>
                  <p>
                    يعتمد النظام على تقسيم الاستهلاك لخمس شرائح: 1-5 م³ مجاناً، 6-15 م³
                    بسعر 7 ل.س، 16-25 م³ بسعر 15 ل.س، 26-35 م³ بسعر 22 ل.س،
                    وما يزيد عن 36 م³ بسعر 150 ل.س للمتر المكعب.
                  </p>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>مثال حسابي</h2>
                  </u>
                  <p>
                    إذا كان استهلاكك 30 متر مكعب شهرياً:
                  </p>
                  <div className="p-3 mb-2 bg-info text-black">
                    الشريحة الأولى (1-5 م³): 5 × 0 = 0 ل.س
                    <br />
                    الشريحة الثانية (6-15 م³): 10 × 7 = 70 ل.س
                    <br />
                    الشريحة الثالثة (16-25 م³): 10 × 15 = 150 ل.س
                    <br />
                    الشريحة الرابعة (26-30 م³): 5 × 22 = 110 ل.س
                    <br />
                    <strong>الإجمالي: 330 ل.س</strong>
                    <br />
                    <small className="text-muted">(3.30 ل.س العملة الجديدة)</small>
                  </div>
                  <br />
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">كم لتر في المتر المكعب؟</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>التحويل بين الوحدات</h2>
                  </u>
                  <p>
                    المتر المكعب الواحد يساوي 1,000 لتر من الماء. معظم عدادات المياه
                    تقيس بالمتر المكعب، بينما نستخدم اللتر في الاستهلاك اليومي.
                  </p>
                  <div className="p-3 mb-2 bg-info text-black">
                    <strong>أمثلة:</strong>
                    <br />
                    • دش لمدة 10 دقائق = 80-100 لتر = 0.08-0.1 م³
                    <br />
                    • غسالة أوتوماتيك (دورة كاملة) = 80 لتر = 0.08 م³
                    <br />
                    • دلو ماء = 10 لترات = 0.01 م³
                  </div>
                  <br />
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">ما هو المعدل الطبيعي لاستهلاك المياه؟</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>المعدلات الطبيعية</h2>
                  </u>
                  <p>
                    • شخص واحد: 3-5 م³/شهر (100-150 لتر يومياً)
                    <br />
                    • عائلة من 4 أشخاص: 12-20 م³/شهر
                    <br />
                    • عائلة من 6 أشخاص: 18-30 م³/شهر
                  </p>
                  <p>
                    هذه المعدلات تشمل الشرب، الطبخ، الاستحمام، الغسيل، والتنظيف.
                    الاستهلاك يزيد في الصيف بسبب الاستحمام المتكرر وسقي النباتات.
                  </p>
                  <br />
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">كيف أكتشف التسريبات؟</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>طرق اكتشاف التسريبات</h2>
                  </u>
                  <p>
                    • أغلق جميع الصنابير والأجهزة المستخدمة للمياه
                    <br />
                    • سجل قراءة العداد قبل النوم
                    <br />
                    • سجل قراءة العداد في الصباح
                    <br />
                    • إذا تغيرت القراءة دون استخدام، لديك تسريب
                  </p>
                  <div className="p-3 mb-2 bg-info text-black">
                    <strong>نقاط الفحص:</strong>
                    <br />
                    • المراحيض (أشهر مصدر للتسريب)
                    <br />
                    • الصنابير والخلاطات
                    <br />
                    • خراطيم الغسالة
                    <br />
                    • سخان المياه
                  </div>
                  <br />
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">لماذا فاتورتي مرتفعة؟</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>الأسباب الشائعة</h2>
                  </u>
                  <p>
                    • تجاوز حد 35 م³ يرفع السعر بشكل كبير (150 ل.س/م³)
                    <br />
                    • تسريبات خفية في المراحيض أو الأنابيب
                    <br />
                    • زيادة استخدام الغسالة أو الاستحمام
                    <br />
                    • سقي الحديقة بشكل مفرط
                    <br />
                    • عداد قديم قد يكون غير دقيق
                  </p>
                  <br />
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">كم يستهلك المرحاض من المياه؟</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>استهلاك المراحيض</h2>
                  </u>
                  <p>
                    • المراحيض القديمة: 12-15 لتر/تدفقة
                    <br />
                    • المراحيض الحديثة: 6-9 لتر/تدفقة
                    <br />
                    • المراحيض الموفرة: 3-4.5 لتر/تدفقة
                  </p>
                  <div className="p-3 mb-2 bg-info text-black">
                    <strong>حساب شهري (عائلة 4 أشخاص، 6 استخدامات يومياً):</strong>
                    <br />
                    • مرحاض قديم: 4 × 6 × 12 × 30 = 8,640 لتر = 8.6 م³
                    <br />
                    • مرحاض موفر: 4 × 6 × 4 × 30 = 2,880 لتر = 2.9 م³
                    <br />
                    <strong>التوفير: 5.7 م³ شهرياً!</strong>
                  </div>
                  <br />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default WaterCalculator;